import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Page from "../../shared/Page";
import Loader from "../../ui/Loader";
import Form from "./Form";

import * as appConfigActions from "../../../actions/appConfigActions";

class AppConfigPage extends React.Component {
	state = {
		isLoaded: false,
		appConfig: false,
	};

	componentDidMount() {
		const { appConfigActions, match } = this.props;
		const { appKey } = match.params;
		appConfigActions.loadAppConfig(appKey);
	}

	onSubmit = (values, submitCallback) => {
		const { appConfigActions, match } = this.props;
		const { appKey } = match.params;
		appConfigActions.saveAppConfig(appKey, values, submitCallback);
	};

	// TODO: Make the header shared?
	render() {
		const {
			appConfig: { appConfig },
		} = this.props;
		return (
			<Page>
				<div className="ta-center">
					<div className="sortable">
						<div className="title-wrapper">
							<h3 className="page-title">App Config</h3>
						</div>
						{Object.keys(appConfig).length > 0 ? (
							<Form initialValues={appConfig} onSubmit={this.onSubmit} />
						) : (
							<Loader />
						)}
					</div>
				</div>
			</Page>
		);
	}
}

AppConfigPage.propTypes = {};

const mapStateToProps = state => ({
	appConfig: state.appConfig,
});

const mapDispatchToProps = dispatch => ({
	appConfigActions: bindActionCreators(appConfigActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AppConfigPage);
